import { render } from "./Checkbox.vue?vue&type=template&id=24512fc9&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=24512fc9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24512fc9"

export default script